import React, { Component, createRef } from "react";
import commonFunction from "../../../lib/utils/common";
import configUrl from "../../../../config/config.json";
import { logout } from "../../../lib/logout";
import Menu from "../../Menu/index";
import {
  setTockenInCoockie,
  getCookieTocken,
  removeUserTokenFromCookie,
} from "../../login/userToken";
import { checksession } from "../../../lib/checksession";
import Link from "../../../Link";
import chat from "../../../lib/chat";
import UploadLogo from "store/uploadLogo";
import GoogleTranslate from "../../googleTranslate/custom.js";
import ModalPopupComponent from "@/commonComponents/ModalPopupComponent/theme5/ModalPopupComponent";

let MenuList = [
  {
    Linkindex: 0,
    isPartition: false,
    linkItem: "My Profile",
    isActiveLink: true,
    componentName: "ProfileForm",
    imgInActiveSrc: "/images/my-profile-g.svg",
    imgActiveSrc: "/images/my-profile-g.svg",
    href: "profile",
  },
  {
    Linkindex: 1,
    isPartition: false,
    linkItem: "My Booking",
    isActiveLink: false,
    componentName: "BookingForm",
    imgInActiveSrc: "/images/my-booking-g.svg",
    imgActiveSrc: "/images/my-booking-g.svg",
    href: "mybooking",
  },
  {
    Linkindex: 2,
    isPartition: false,
    linkItem: "Guest & Traveler",
    isActiveLink: false,
    componentName: "GuestTravelerForm",
    imgInActiveSrc: "/images/guestTravel-g.svg",
    imgActiveSrc: "/images/guestTravel-g.svg",
    href: "guesttraveler",
  },
  {
    Linkindex: 3,
    isPartition: false,
    linkItem: "Travel Preferences",
    isActiveLink: false,
    componentName: "TravelPreferencesForm",
    imgInActiveSrc: "/images/prefernce-g.svg",
    imgActiveSrc: "/images/prefernce-g.svg",
    href: "travelpreferences",
  },
  {
    Linkindex: 6,
    isPartition: false,
    linkItem: "My Frequent Flyer",
    isActiveLink: false,
    componentName: "FrequentFlyerForm",
    imgInActiveSrc: "/images/flyer-g.svg",
    imgActiveSrc: "/images/flyer-g.svg",
    href: "frequentflyer",
  },
  {
    Linkindex: 10,
    isPartition: false,
    linkItem: "Change Password",
    isActiveLink: false,
    componentName: "ChangePasswordForm",
    imgInActiveSrc: "/images/changePwd-g.svg",
    imgActiveSrc: "/images/changePwd-g.svg",
    href: "changepassword",
  },
  {
    Linkindex: 11,
    isPartition: false,
    linkItem: "Logout",
    isActiveLink: false,
    componentName: "Logout",
    imgInActiveSrc: "/images/Logout-g.svg",
    imgActiveSrc: "/images/Logout-g.svg",
    href: "Logout",
  },
];

class MobileHeader1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isToken: "",
      isShowPopup: false,
      userFirststname: "",
      userLaststname: "",
      open: false,
      scrolling: false,
      isTranslatePopup: false,
      language: "en",
    };
    this.supportWrapperRef = React.createRef();
    this.dropdownRef = React.createRef();
  }

  setSupportWrapperRef = (node) => {
    this.supportWrapperRef = node;
  };

  handleCalendarClickOutside = (event) => {
    if (
      !this.supportWrapperRef.current ||
      !this.supportWrapperRef.current?.contains(event.target)
    ) {
      this.setState({ openSupportPopup: false });
    }
  };

  handleDropdownClickOutside = (event) => {
    if (
      this.state.isTranslatePopup &&
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target)
    ) {
      this.setState({ isTranslatePopup: false });
    }
  };

  handleDropdownBlur = (event) => {
    if (
      this.state.isTranslatePopup &&
      this.dropdownRef.current &&
      event.relatedTarget &&
      !this.dropdownRef.current.contains(event.relatedTarget)
    ) {
      this.setState({ isTranslatePopup: false });
    }
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    document.addEventListener("mousedown", this.handleCalendarClickOutside);
    document.addEventListener("mousedown", this.handleDropdownClickOutside);
    if (this.props?.data?.siteData?.site?.allow_multilingual) {
      let googtransCookie = commonFunction.getCookie("googtrans");
      let language =
        googtransCookie != "" ? googtransCookie.split("/")[2] : "en";
      this.setState({ language });
    }
    chat(this.props?.data?.siteData?.site?.chat, this.props?.data?.isMobile);
    if (this.props?.data?.user?.status) {
      this.setState({
        userFirststname: this.props?.data?.user?.first_name
          ? this.props?.data?.user?.first_name?.charAt(0)
          : this.props?.data?.user?.email?.charAt(0),
        userLaststname: this.props?.data?.user?.first_name
          ? this.props?.data?.user?.last_name?.charAt(0)
          : this.props?.data?.user?.email?.charAt(0),
        newToken: this.props?.data?.user?.accessToken || "",
      });
    } else {
      this.setState({
        userFirststname: "",
        userLaststname: "",
        newToken: "",
      });
    }
  }

  onClickArrow = () => {
    this.setState({
      isShowPopup: !this.state.isShowPopup,
    });
  };

  onMouseLeave = () => {
    this.setState({
      isShowPopup: false,
    });
  };

  onClickProfile = () => {
    commonFunction.redirectTo("/myprofile");
  };

  onClickLogout = () => {
    logout()
      .then((responseJSON) => {
        if (
          responseJSON.status &&
          responseJSON.message === "Logout successfull"
        ) {
          this.setState({
            newToken: "",
            userFirststname: "",
            userLaststname: "",
          });
          location.reload();
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  onClickMenu = (bool) => {
    this.setState({ open: bool });
  };

  onClickTab = (id) => {
    let newdata = MenuList.map((fact, index) => {
      if (id == index) {
        let data = {
          ...fact,
          active: true,
        };
        return data;
      } else {
        let data = {
          ...fact,
          active: false,
        };
        return data;
      }
    });
    MenuList = newdata;
    this.setState({ open: false });
  };

  componentWillUnmount = () => {
    window.removeEventListener("scroll", this.handleScroll);
    document.removeEventListener("mousedown", this.handleCalendarClickOutside);
    document.removeEventListener("mousedown", this.handleDropdownClickOutside);
  };

  handleScroll = (event) => {
    if (window.scrollY <= 100 && this.state.scrolling === true) {
      this.setState({ scrolling: false });
    } else if (window.scrollY > 100 && this.state.scrolling !== true) {
      this.setState({ scrolling: true });
    }
  };

  render() {
    return (
      <header className="mobile-header theme5">
        {this.props.data.pathname === "/myprofile" ? null : (
          <div
            className={`${this.props.data.cssfile.main_logo_header}  ${
              this.state.scrolling === true
                ? this.props.data.cssfile.header_stickyMobile
                : ""
            }`}
          >
            <div className={this.props.data.cssfile.logosub_header}>
              {true? (
                (this.props?.data?.user?.loyalty?.hasOwnProperty('is_guest')&&!this.props?.data?.user?.loyalty?.is_guest)? (
                  <div
                    className={this.props.data.cssfile.afterlogin}                    
                  >
                    <span
                      className={this.props.data.cssfile.user_code}
                      onClick={() => {
                        this.onClickMenu(!this.state.open);
                      }}
                    >
                      <img src="images/eth_user_login_Icon.svg" alt="Login" />
                      {/* {this.state.userFirststname}
                      {this.state.userLaststname} */}
                    </span>
                  </div>
                ) : (
                  <span
                    className={this.props.data.cssfile.login_btn}
                    onClick={this.props.data.onClickHeaderLogin}
                  >
                    <span onClick={this.props.data.onClickHeaderLogin}>
                      <img src="images/eth_user_login_Icon.svg" alt="Login" />
                    </span>
                  </span>
                )
              ) : (
                []
              )}
              <Menu
                    theme={"theme13" }                   
                    clickedTab={this.onClickTab}
                    onclickLogout={this.onClickLogout}
                    styles={this.props.data.menucssfile}
                    isopen={this.state.open}
                    MenuList={MenuList}
                    id={"main-menu"}
                    pathname={
                      this.props.data.pathname === "/myprofile"
                        ? new URLSearchParams(window.location.search).get(
                            "Linkindex"
                          ) !== null
                          ? this.props.data.pathname
                          : "myprofile"
                        : this.props.data.pathname
                    }
                    closeMenusHandler={this.onClickMenu}
                  />
              {this.state.newToken != undefined &&
                this.state.newToken != null &&
                this.state.newToken != "" && (
                  <p className={this.props.data.cssfile.welcome_text}>
                  </p>
                )}
            </div>
            <div className={this.props.data.cssfile.branchlogomobo}>
              <a
                title="Logo"
                key={"logo"}
                href={this.props?.data?.siteData?.site?.sso?.parent_url||"/"}
                
                className={this.props.data.cssfile.mobile_logo_header}
              >
                <img
                  height="25"
                  width="80"
                  className={this.props?.data?.cssfile?.header_logo}
                  src={`${
                    "/shared/api/media/" +
                    this.props?.data?.site_id +
                    "/" +
                    (UploadLogo?._currentValue?.isLogo
                      ? this.props?.data?.headermenu?.mobile?.logo
                      : this.props?.data?.headermenu?.mobile?.logo)
                  }`}
                  alt="logo"
                />
              </a>
            </div>
            <div className={this.props.data.cssfile.logo_header}>
              <ul className={this.props.data.cssfile.navbar_right}>
                <li
                  className={this.props.data.cssfile.dropdown}
                  ref={this.dropdownRef}
                  tabIndex={0}
                  onClick={() => this.setState({ isTranslatePopup: !this.state.isTranslatePopup })}
                  onBlur={this.handleDropdownBlur}
                  style={{
                    display: this.props.data.showTranslation ? "block" : "none",
                  }}
                >
                  <span className={this.props.data.cssfile.dropdown_span}>
                    <div className={`${this.props.data.cssfile.support_main} ${this.state.isTranslatePopup ? this.props.data.cssfile.support_main_active : ""}`}>
                      <img src="images/eth_Support.svg" alt="support" width={20} height={20} />
                    </div>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        )}

       {this.state.isTranslatePopup&& <div className={this.props.data.cssfile.translate_modal}>
          <div>
              <div className={this.props.data.cssfile.footer_contact}>
                <div className={this.props.data.cssfile.flex_row}>
                  {this.props?.data?.siteData?.site?.support_number && 
                  <div className={this.props.data.cssfile.contactinfo}>
                    <a></a>
                    {this.props?.data?.siteData?.site?.support_number&&<a
                      href={
                        localStorage.getItem("appType") == "mobileapp"
                          ? "/mobileAppLink?page=supportNo&value=" +
                            this.props?.data?.siteData?.site?.support_number
                          : `tel:${this.props?.data?.siteData?.site?.support_number}`
                      }
                    >
                      <span>
                        <img src="images/eth-telephone-call.svg" alt="phone" width={24} height={24} />
                       {" "}
                        {this.props?.data?.siteData?.site?.support_number}{" "}
                      </span>{" "}
                    </a>}
                  </div>
                  }
                  <div className={this.props.data.cssfile.contactinfo}>
                    <a
                      href={
                        localStorage.getItem("appType") == "mobileapp"
                          ? "/mobileAppLink?page=supportEmail&value=" +
                            this.props?.data?.siteData?.site?.support_email
                          : `mailto:${this.props?.data?.siteData?.site?.support_email}`
                      }
                    >
                      <span>
                      <img src="images/eth-email-icon.svg" alt="phone" width={24} height={24} />
                        {" "}
                        {this.props?.data?.siteData?.site?.support_email}{" "}
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
        </div>}
      </header>
    );
  }
}

export default MobileHeader1;
